export default __webpack_public_path__ + "static/media/teamMember5.ed06095e.png";